class ImageAspectRatio
{
	constructor()
	{
		if (document.querySelector('.content-page__side-bar'))
		{
			this.applyRatios();
		}
	}

	private applyRatios()
	{
		const mainContent = document.querySelector('.content-page__main-content');
		if (mainContent)
		{
			// The asset tag helper only publishes data-width and data-height for an image served at the asset's own
			// ratio, so these describe what will load. An image whose component CSS sets an aspect ratio keeps it.
			// Everything is read before anything is written, so that styling one image does not force a reflow
			// when the next is measured.
			const images = Array.from(mainContent.querySelectorAll<HTMLImageElement>('img[data-width][data-height]'))
				.map(img => ({
					img,
					w: parseInt(img.getAttribute('data-width') || '0', 10),
					h: parseInt(img.getAttribute('data-height') || '0', 10),
					sizedByCss: getComputedStyle(img).aspectRatio !== 'auto'
				}));

			images.forEach(({ img, w, h, sizedByCss }) =>
			{
				if (w > 0 && h > 0 && !sizedByCss)
				{
					const ratio = h / w;

					img.style.display = 'block';

					const parent = img.parentElement;
					if (parent)
					{
						parent.style.position = 'relative';
						parent.style.paddingBottom = `${ratio * 100}%`;
						img.style.position = 'absolute';
						img.style.top = '0';
						img.style.left = '0';
						img.style.width = '100%';
						img.style.height = '100%';
					}
				}
			});
		}
	}
}

document.addEventListener('DOMContentLoaded', () =>
{
	new ImageAspectRatio();
});
